import React from 'react';
import { useTranslation } from 'react-i18next';
import AllergenIcon from './AllergenIcon.jsx';

const AllergenBadge = ({ 
  allergens = [], 
  variant = 'default', 
  size = 'sm',
  showCount = false,
  maxDisplay = 3,
  className = ''
}) => {
  const { t } = useTranslation();
  if (!allergens || allergens.length === 0) {
    return null;
  }

  const variants = {
    default: 'bg-destructive/10 text-destructive',
    warning: 'border border-[#B3E8F2] dark:border-[#2A4A5A] text-card-foreground',
    danger: 'bg-destructive/20 text-destructive',
    info: 'bg-chart-1/10 text-chart-1'
  };

  const sizes = {
    xs: 'px-1.5 py-0.5 text-xs',
    sm: 'px-2 py-1 text-sm',
    md: 'px-3 py-1.5 text-base',
    lg: 'px-4 py-2 text-lg'
  };

  const iconSizes = {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
    lg: 'lg'
  };

  const variantClass = variants[variant] || variants.default;
  const sizeClass = sizes[size] || sizes.sm;
  const iconSize = iconSizes[size] || iconSizes.sm;

  // If showCount is true and we have more allergens than maxDisplay, show count
  if (showCount && allergens.length > maxDisplay) {
    return (
      <div className={`inline-flex items-center gap-1 border rounded-full ${variantClass} ${sizeClass} ${className}`}>
        <AllergenIcon allergenId="wheat" size={iconSize} />
        <span className="font-medium whitespace-nowrap">
          {allergens.length} {t('common.allergens')}
        </span>
      </div>
    );
  }

  // Show individual allergen badges
  const displayAllergens = allergens.slice(0, maxDisplay);
  const remainingCount = allergens.length - maxDisplay;

  return (
    <div className={`inline-flex items-center gap-1 ${className}`}>
      {displayAllergens.map((allergenId, index) => (
        <div
          key={allergenId}
          className={`inline-flex items-center gap-1 border rounded-full ${variantClass} ${sizeClass}`}
          title={`${t('common.allergen')}: ${t(`allergens.${allergenId}`)}`}
        >
          <AllergenIcon allergenId={allergenId} size={iconSize} />
          <span className="font-medium whitespace-nowrap">{t(`allergens.short.${allergenId}`)}</span>
        </div>
      ))}
      
      {remainingCount > 0 && (
        <div className={`inline-flex items-center gap-1 border rounded-full ${variantClass} ${sizeClass}`}>
          <span className="font-medium whitespace-nowrap">+{remainingCount}</span>
        </div>
      )}
    </div>
  );
};

export default AllergenBadge;
